module.exports = __webpack_public_path__ + "img/thaddeus-stevens.1cf62c38.png";